import React from 'react';
import { projectsApiService } from '../../../graphql/projects/projectsApiService';
import ProgressBar from '../Progress/ProgressBar';
import VoxelAlert from '../../voxel/Alert/VoxelAlert';
import VoxelDialog from '../../voxel/Dialogs/VoxelDialog';
import VoxelDialogActionSubmit from '../../voxel/Dialogs/VoxelDialogActionSubmit';
import VoxelDialogActions from '../../voxel/Dialogs/VoxelDialogActions';
import VoxelDialogContent from '../../voxel/Dialogs/VoxelDialogContent';
import VoxelText from '../../voxel/Text/VoxelText';

export interface CopyInProgressDialogProps {
  projectId: number;
  closeDialog: () => void;
  goToProject: () => void;
}

const CopyInProgressDialog: React.FC<CopyInProgressDialogProps> = ({
  projectId,
  closeDialog,
  goToProject,
}) => {
  const progressQuery = projectsApiService.queries.useGetCopyProgress(projectId, {
    pollInterval: 350,
  });

  const projectQuery = projectsApiService.queries.useGetProject(
    { id: projectId },
    {
      pollInterval: 350,
    }
  );

  if (!progressQuery?.result || !projectQuery?.result) {
    return null;
  }

  return (
    <VoxelDialog
      title={projectQuery?.result?.exampleProject ? 'Preparing example project' : 'Copying project'}
      open={true}
      onClose={closeDialog}
    >
      <VoxelDialogContent>
        {!!projectQuery?.result?.copyFailed && (
          <VoxelAlert severity="error" title="Copying the project failed">
            Try copying again and contact the Voxel team if the problem persists.
          </VoxelAlert>
        )}

        {!projectQuery?.result?.copyFailed && (
          <div>
            {progressQuery.result.totalKeywordsCount === 0 && (
              <div className="w-full flex flex-row items-center gap-4">
                <div className="grow-0">
                  <VoxelText>Copy progress</VoxelText>
                </div>
                <div className="grow">
                  <ProgressBar current={!projectQuery.result.copyInProgress ? 1 : 0} total={1} />
                </div>
              </div>
            )}
            {progressQuery.result.totalKeywordsCount > 0 && (
              <div className="w-full flex flex-row items-center gap-4">
                <div className="grow-0">
                  <VoxelText>Keywords</VoxelText>
                </div>
                <div className="grow">
                  <ProgressBar
                    current={progressQuery.result.completedKeywordsCount}
                    total={progressQuery.result.totalKeywordsCount}
                  />
                </div>
              </div>
            )}
          </div>
        )}
      </VoxelDialogContent>
      <VoxelDialogActions>
        <VoxelDialogActionSubmit
          onClick={goToProject}
          disabled={projectQuery.result.copyInProgress}
          title="Continue to project"
        />
      </VoxelDialogActions>
    </VoxelDialog>
  );
};

export default CopyInProgressDialog;
